import { BRAND } from '@/data/content';

export function BBBSeal({ size = 'md', className = '', linked = true, testId = 'bbb-seal' }) {
  const sizeClass = size === 'lg' ? 'h-28' : size === 'sm' ? 'h-20' : 'h-24';
  const img = (
    <img
      src={BRAND.bbbSeal}
      alt="HearthOak Construction, LLC — BBB Accredited"
      className={`${sizeClass} w-auto flex-shrink-0 bg-white p-1 border border-brand-border ${className}`}
      data-testid={testId}
    />
  );
  if (!linked) return img;
  return (
    <a href={BRAND.bbbUrl} target="_blank" rel="nofollow noopener noreferrer" aria-label="HearthOak Construction BBB Business Review" className="inline-block flex-shrink-0">
      {img}
    </a>
  );
}

export function TrustLine({ className = '', items = ['BBB Accredited', 'Owner-led craftsmanship', 'Clear communication', 'Work done with care'] }) {
  return (
    <p className={`flex flex-wrap items-center gap-y-1 font-sans text-xs md:text-sm tracking-wide text-brand-muted ${className}`} data-testid="trust-line">
      {items.map((t, i) => (
        <span key={t} className="whitespace-nowrap">
          {t}
          {i < items.length - 1 && <span className="mx-2 text-brand-maroon">•</span>}
        </span>
      ))}
    </p>
  );
}

export function SectionHeading({ eyebrow, title, kicker, align = 'left', className = '' }) {
  return (
    <div className={`${align === 'center' ? 'text-center mx-auto max-w-2xl' : 'max-w-3xl'} ${className}`}>
      {eyebrow && <div className="eyebrow mb-3">{eyebrow}</div>}
      <h2 className="h2">{title}</h2>
      {kicker && <p className="body-lg mt-4">{kicker}</p>}
    </div>
  );
}

// Cropped view into the composite photo — kept for legacy uses.
export function CompositeCrop({ pos = { x: '50%', y: '50%', scale: 2 }, className = '', alt = 'Real project photo' }) {
  return (
    <div className={`crop-frame w-full ${className}`}>
      <img
        src={BRAND.composite}
        alt={alt}
        style={{ transform: `scale(${pos.scale})`, transformOrigin: `${pos.x} ${pos.y}` }}
      />
    </div>
  );
}

// Real project photo — renders an image with object-cover inside an aspect-ratio box.
export function PortfolioImage({ src, alt = 'Real project photo', className = '' }) {
  return (
    <div className={`crop-frame w-full bg-brand-charcoal ${className}`}>
      <img src={src} alt={alt} loading="lazy" />
    </div>
  );
}
